module.exports = __webpack_public_path__ + "img/compositeSing.5bf2c8a0.png";